import * as React from 'react';
import { HeaderColumn } from '@tableau/widgets-datagrid';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { style } from 'typestyle';

const headerStyle = style({
  ...CommonStyles.Layout.TextEllipsis,
  marginLeft: CommonStyles.Sizes.MediumSpace,
});

export function PlainTextHeader(styleOverride?: React.CSSProperties): React.StatelessComponent<HeaderColumn.HeaderFormatterProps> {
  return React.createFactory(class extends React.Component<HeaderColumn.HeaderFormatterProps, any> {
    render() {
      return (
        <div className={ headerStyle } style={styleOverride}>
          { this.props.col.headerText }
        </div>
      );
    }
  });
}
